"use client";

import { createElement, type ReactNode } from "react";
import { MaintenancePage } from "@zzk/admin-pages";

export function readMaintenanceModeFromMeta(): boolean {
  try {
    const meta = document.querySelector(
      'meta[name="zzk-public-maintenance-mode"]',
    );
    return meta?.getAttribute("content") === "true";
  } catch {
    return false;
  }
}

export interface MaintenanceGateProps {
  readonly children?: ReactNode;
}

export function MaintenanceGate({ children }: MaintenanceGateProps) {
  const isMaintenanceMode = readMaintenanceModeFromMeta();

  if (isMaintenanceMode) {
    return createElement(MaintenancePage, null);
  }

  return createElement("div", null, children);
}
